export const getChartAccountBalance = (invoiceAmount: number, amounts: number[]) => {
  const sum = amounts.reduce((total, amount) => total + Number(amount), 0);
  const differenceCents = Math.round(sum * 100) - Math.round(Number(invoiceAmount) * 100);
  const withinTolerance = Math.abs(differenceCents) <= 1;

  return {
    sum,
    exceedsTotal: differenceCents > 1,
    rest: withinTolerance ? 0 : Math.max(0, -differenceCents / 100),
  };
};
